import i18n from 'i18next';

export default ({ enrolledUsers }) => {
  if (!enrolledUsers) return [];

  const {
    data: {
      meta: { statuses },
    },
  } = enrolledUsers;

  return statuses.map((status, index) => ({
    id: index + 1,
    value: status,
    label: i18n.t(status),
  }));
};
